import gql from "graphql-tag";

export const GET_PRESIGNED_URL = gql`
	query GetFilePresignedUrl($documentId: Int!, $fileId: Int!, $text: Boolean!) {
		filePresignedUrl(documentId: $documentId, fileId: $fileId, text: $text) {
		  url
		  fileName
		}
	}
`;
